// Revalidación de build — forzar nueva firma de assets (rebuild fix).
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import { ThemeProvider } from '@/lib/theme'
import '@/index.css'
import { initUiSounds } from '@/lib/uiSound'

// Filtra los "Script error." que lanzan scripts de terceros cross-origin
// (Cloudflare Turnstile, Google Maps, Stripe) cuando no pueden exponer el
// detalle del error (sin cabeceras CORS / sin atributo crossorigin). El
// navegador los reporta como { message: "Script error.", filename: "",
// lineno: 0, colno: 0 } — sin información accionable desde la app. Los
// errores reales (mismo origen) traen filename/lineno/colno y un mensaje
// útil, así que esos pasan sin filtrarse.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    if (
      e &&
      (e.message === 'Script error.' || e.message === 'Script error') &&
      (!e.filename || e.filename === '') &&
      (e.lineno === 0 || e.lineno == null) &&
      (e.colno === 0 || e.colno == null)
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
)

initUiSounds();

// Registra el Service Worker de la PWA (public/sw.js) SOLO en producción.
// En dev (Vite) el SW cache-first capturaría /node_modules/.vite/deps/react.js
// y serviría un bundle de React obsoleto (con exports en null), rompiendo los
// hooks ("Cannot read properties of null (reading 'useState')"). En dev
// desregistramos cualquier SW anterior y limpiamos sus cachés para evitar
// servir JS/CSS obsoletos.
if ('serviceWorker' in navigator && location.protocol.startsWith('http')) {
  window.addEventListener('load', () => {
    if (import.meta.env.DEV) {
      navigator.serviceWorker.getRegistrations()
        .then((regs) => Promise.all(regs.map((r) => r.unregister())))
        .then(() => {
          if ('caches' in window) {
            caches.keys().then((keys) => Promise.all(keys.filter((k) => k.startsWith('bhgc-')).map((k) => caches.delete(k))));
          }
        })
        .catch(() => {});
      return;
    }
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}